<script setup lang="ts">

//vue
import { onMounted, reactive,} from "vue";
import { useRouter, useRoute } from 'vue-router';

//servicos
import * as service from "@/services/BoletosService";
import {  fdata, f2dec,  fdataHora,  } from "@/utils/funcoes";

//componentes
import Pesquisa from "./Pesquisa.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import Loading from "@/components/Loading/index.vue"
import Paginador from "@/components/Paginador/Index.vue"
import Pergunta from "@/components/Pergunta/Index.vue"
import RetornoItensTarifas from "./RetornoItensTarifas.vue"
import RetornoItensStatusProcess from "./RetornoItensStatusProcess.vue"

//janelas

const router = useRouter();
const route = useRoute();

type configColuna = {
    coluna: string;
    exibe: boolean;
};


var controle = reactive({
    filtros: {
        retornoId: 0 ,
        paginaAtual: 1,
        tamanhoPagina: 30,
        statusProcessamento: "",
    } as service.ObterRetornoItensFiltros,

    retorno: {} as service.BoletoRetorno,
    itens: [] as service.BoletoRetornoItemDTO[],
    tarifas: [] as service.BoletoRetornoItemDTO[],

    id: 0 as number,
    item: {} as service.BoletoRetornoItemDTO,

    boletoId: 0 as number,
    boleto: {} as service.Boleto,
    
    listaResumo: [] as service.RetornoPorOcorrenciaDto[],
    listaPorStatus: [] as service.RetornoPorStatusDto[],


    resumo: {} as service.RetornoPorOcorrenciaDto,

    ordemDirecao: "Desc",
    ordemColuna: "BoletoId",
    totalRegistros: 0,
    totais: {
        qtde: 0,
        total: 0,
    },
    colunas: [
        { coluna: "Id", exibe: true },
        { coluna: "Banco", exibe: true },
        { coluna: "Nosso Número", exibe: true },
        { coluna: "Docto Origem", exibe: true },
        { coluna: "Dt. Emissão", exibe: true },
        { coluna: "Dt. Vencto", exibe: true },
        { coluna: "Cliente", exibe: true },
        { coluna: "Razão social", exibe: true },
        { coluna: "Valor R$", exibe: true },
        { coluna: "Tipo Ocorrência", exibe: true },
        { coluna: "Usuário", exibe: true },
        { coluna: "Sequencial", exibe: true },
        { coluna: "Status", exibe: true },
    ] as configColuna[],

    janColunas: false,
    janDetalhes: false,


    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

    // Estados do diálogo de confirmação
    showConfirmDialog: false,
    processandoRetorno: false,

});



onMounted(() => {
    controle.filtros.retornoId = parseInt(route.params.id.toString());
    buscarResumo();
    pesquisar();
    buscarTarifas();
})

const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.itens = [] as service.BoletoRetornoItemDTO[];
    console.log("pesquisar");

    service.obterRetornoDetalhes(controle.filtros)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.itens = r.dados
            controle.totalRegistros = r.totalRegistros;

            controle.totais.total = 0;

            controle.itens.forEach((boleto) => {
                controle.totais.qtde++;
                controle.totais.total += (boleto.valorDocumento ?? 0);
            });
        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

const buscarTarifas = async () => {

    controle.tarifas = [] as service.BoletoRetornoItemDTO[];

    service.obterRetornoDetalhes({ocorrenciaIds: ["161"], retornoId: controle.filtros.retornoId, paginaAtual: 1, tamanhoPagina: 1000})
        .then((r) => {
            controle.tarifas = r.dados
        })
        .catch((erro: string) => {
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

function buscarResumo() {

    controle.listaResumo = [] as service.RetornoPorOcorrenciaDto[];

    service.obterRetornoResumo(controle.filtros.retornoId as number)
    .then((r) => {
        controle.retorno = r.retorno;
        controle.listaResumo = r.resumoPorOcorrencia;
        controle.listaPorStatus = r.resumoPorStatus;
    })
    .catch((erro: string) => {
        console.error("Erro ao obter resumo do retorno:", erro);
    });

}

const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.itens = controle.itens.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
    else
        controle.itens = controle.itens.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
}

function exibirDetalhes(boleto: service.Boleto) {
    controle.boleto = boleto;
    controle.boletoId = boleto.boletoId ?? 0;
    controle.janDetalhes = true;
}

function selecionarResumo(resumo: service.RetornoPorOcorrenciaDto | null) {
    if (resumo == null) {
        controle.resumo = {} as service.RetornoPorOcorrenciaDto;
        controle.filtros.paginaAtual = 1;
        controle.filtros.tamanhoPagina = 30;
        controle.filtros.ocorrenciaIds = [];
        controle.filtros.statusProcessamento = "";
        pesquisar();
        return;
    }

    controle.filtros.paginaAtual = 1;
    controle.filtros.tamanhoPagina = resumo.qtde + 50;
    controle.filtros.ocorrenciaIds = [resumo.ocorrenciaId];
    controle.filtros.statusProcessamento = "";
    pesquisar();
    controle.resumo = resumo;
}

// Função para mostrar confirmação antes de processar retorno
function perguntaProcessar() {
    controle.showConfirmDialog = true;
}

// Função chamada quando o usuário responde ao diálogo
function confirmaProcessar(confirmou: boolean) {
    controle.showConfirmDialog = false;
    
    if (confirmou && controle.filtros.retornoId != null) {
        processarRetorno();
    }
    
}

// Função para processar o retorno
async function processarRetorno() {
    try {
        controle.loading = true;
        controle.processandoRetorno = true;
        controle.status = "Processando retorno...";
        
        // Aqui você chamaria o serviço para processar o retorno
        await service.processarRetorno(controle.filtros.retornoId as number);
        
        // Simular processamento por 2 segundos
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        controle.status = "Retorno processado com sucesso!";
        
        pesquisar();

        setTimeout(() => {
            controle.loading = false;
            controle.processandoRetorno = false;
        }, 3000);

        
    } catch (erro) {
        
        controle.erro = `Erro ao processar retorno: ${erro}`;

    } finally {
        
        controle.processandoRetorno = false;
        controle.loading = false;

        setTimeout(() => {
            controle.status = "";
        }, 3000);
    }
}


</script>

<template>
    <NavBarStatus :erro="controle.erro" @limparErro="controle.erro = ''" />

    <Loading :isLoading="controle.loading" :mensagem="controle.status" />
    
    <Container :width="'full'" :class="'p-0  overflow-hidden h-100'" class="p-0">
        <div class="p-2 bg-light">
            
            <!-- Breadcrumb -->
            <div class="row">
                <div class="col-md-6 col-12 ">
                    
                    <BreadCrumb :-page-title="'Retornos'" 
                        :items="[
                            { label: 'Boletos', to: '/boletos' },
                            { label: 'Retornos', to: '/boletosRetornos' },
                            { label: `Retorno ${controle.filtros.retornoId}`, to: '#' },
                        ]" />

                </div>

                <div class="col-md-3 col-12 fs-6 fw-bold">
                    Data: {{ fdataHora(controle.retorno.dataCadastro) }} 
                </div>

                <div class="col-md-3 col-12 fs-6 fw-bold">
                    Cedente: {{ controle.retorno.cedenteCodigo }} 
                </div>

            </div>


            <div class="row">
                <div class="col-md-6 col-12 ">

                    <div class="row">
                        <div class="col-md-12 col-12 fs-6 fw-bold">
                            Resumo por Ocorrência
                        </div>
                        <div class="col-md-12 div-table-resumo">
                            
                            <table class="table table-sm table-bordered">
                                <thead>
                                    <tr>
                                        <th>Cód</th>
                                        <th>Ocorrência</th>
                                        <th class="text-end">Qtde</th>
                                        <th class="text-end">Recebido</th>
                                        <th class="text-end">Juros</th>
                                        <th class="text-end">Out Créd</th>
                                        <th class="text-end">Desc</th>
                                        <th class="text-end">Docto</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in controle.listaResumo" 
                                    :key="item.ocorrenciaId" 
                                    @click="selecionarResumo(item)" 
                                    style="cursor: pointer;"
                                    :class="item.ocorrenciaId == controle.resumo.ocorrenciaId ? 'table-active' : ''">
                                        <td>{{ item.ocorrenciaId }}</td>
                                        <td>{{ item.descricao }}</td>
                                        <td class="text-end">{{ item.qtde }}</td>
                                        <td class="text-end">{{ f2dec(item.valorRecebido) }}</td>
                                        <td class="text-end">{{ f2dec(item.valorMoraJuros) }}</td>
                                        <td class="text-end">{{ f2dec(item.valorOutrosCreditos) }}</td>
                                        <td class="text-end">{{ f2dec(item.valorDescontos) }}</td>
                                        <td class="text-end">{{ f2dec(item.valorDocumento) }}</td>
                                    </tr>

                                    <tr  @click="selecionarResumo(null)" 
                                    style="cursor: pointer;"
                                    :class="controle.resumo == null ? 'table-active' : ''">
                                        <td></td>
                                        <td>Totais</td>
                                        <td class="text-end fw-bold">{{ controle.listaResumo.reduce((acc, item) => acc + item.qtde, 0) }}</td>
                                        <td class="text-end fw-bold">{{ f2dec(controle.listaResumo.reduce((acc, item) => acc + item.valorRecebido, 0)) }}</td>
                                        <td class="text-end fw-bold">{{ f2dec(controle.listaResumo.reduce((acc, item) => acc + item.valorMoraJuros, 0)) }}</td>
                                        <td class="text-end fw-bold">{{ f2dec(controle.listaResumo.reduce((acc, item) => acc + item.valorOutrosCreditos, 0)) }}</td>
                                        <td class="text-end fw-bold">{{ f2dec(controle.listaResumo.reduce((acc, item) => acc + item.valorDescontos, 0)) }}</td>
                                        <td class="text-end fw-bold">{{ f2dec(controle.listaResumo.reduce((acc, item) => acc + item.valorDocumento, 0)) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-12">
                            <RetornoItensTarifas :itens="controle.tarifas" />
                        </div>

                        <div class="col-md-12">
                            <RetornoItensStatusProcess v-if="controle.filtros.ocorrenciaIds" :itens="controle.listaPorStatus"  :ocorrencia-id="controle.filtros?.ocorrenciaIds[0]"
                            @filtrar="(a)=> {console.log('filtro',a.statusProcessamento); controle.filtros.statusProcessamento = a.statusProcessamento; pesquisar(); }"/>
                        </div>
                    </div>
                </div>

                 

            </div>

            <div class="row mb-2">
                 <div class="col-md-4 col-12">
                    <label>Nome</label>
                    <input v-model="controle.filtros.nome" class="form-control form-control-sm" @keyup="pesquisar()"/>
                </div>

                <div class="col-md-2 col-12">
                    <label>Nosso número</label>
                    <input v-model="controle.filtros.nossoNumero" type="text" class="form-control form-control-sm"  @keyup="pesquisar()"/>
                </div>

                <div class="col-md-2 col-12">
                    <a class="btn btn-primary btn-sm mt-3" @click="pesquisar()"> 
                        <i class="fa fa-search"></i> Pesquisar
                    </a>
                </div>

                 <div class="col-md-4 col-12">
                    <RouterLink :to="'/boletosRetornosDiferencas/' + controle.filtros.retornoId" class="btn btn-primary btn-sm mt-3 float-end" > 
                        <i class="fa fa-search"></i> Diferenças
                    </RouterLink>
                </div>
            </div>

            <div class="row pe-2">
                <div class="col-md-12 div-table-boletos pe-2" >
                    <table class="table table-striped table-hover table-sm table-bordered" style="min-width: 1800px;">
                        <thead class="th-fixed">
                            <tr>
                                <th class="text-start" @click="ordenarPor('numeroDocumento')" >
                                    Nro Docto
                                </th>
                                <th class="text-start" @click="ordenarPor('nossoNumero')" >
                                    Nosso Número
                                </th>
                                <th class="text-start" @click="ordenarPor('Pedido')" v-if="controle.filtros.ocorrenciaId == null" >
                                    Ocorrência
                                </th>
                                <th class="text-end" @click="ordenarPor('clienteId')" >Cliente</th>
                                <th class="text-start" @click="ordenarPor('clienteNome')"  >Razão social</th>
                                <th class="text-center" @click="ordenarPor('dataVencimento')" >Dt. Vencto</th>
                                
                                <th class="text-end" @click="ordenarPor('vendedorNome')" >Recebido R$</th>
                                <th class="text-end" @click="ordenarPor('vendedorNome')" >Juros R$</th>
                                <th class="text-end" @click="ordenarPor('vendedorNome')" >Out Créd R$</th>
                                <th class="text-end" @click="ordenarPor('vendedorNome')" >Desctos R$</th>
                                <th class="text-end" @click="ordenarPor('nomeCidade')" >Docto R$</th>
                                <th class="text-start" @click="ordenarPor('vendedorNome')" >Detalhes</th>
                                <th class="text-start" @click="ordenarPor('vendedorNome')" >Status Processamento</th>
                                <th class="text-center">Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="controle.pesquisando == true">
                                <td colspan="15" class="text-center">
                                    <div class="d-inline">
                                        <i class="fa fa-cog fa-spin"></i>
                                        Pesquisando... 
                                    </div>
                                </td>
                            </tr>
                            <tr class="col-md-12 text-center table-danger" v-show="controle.erro != ''">
                                <td colspan="15" class="text-center">
                                    <div class="d-inline">
                                        <i class="fa fa-exclamation"></i>
                                        {{ controle.erro }}
                                    </div>
                                    <a class="btn btn-primary btn-sm" @click="pesquisar()">Repetir</a>
                                </td>
                            </tr>

                            <tr v-for="(item, idx) in controle.itens" 
                                :key="idx" 
                                :class="controle.id == item.id ? 'table-active' : (item.clienteId == 0 ? 'table-danger' : '')"
                                @click="controle.id = item.id; controle.item = item">

                                <td class="text-start" data-label="Nro Docto" > 
                                    {{ item.numeroDocumento }}
                                </td>
                                <td class="text-start" data-label="Nosso Numero" > 
                                    {{ item.nossoNumero }}
                                </td>
                                  <td class="text-start" data-label="Nosso Numero" v-if="controle.filtros.ocorrenciaId == null"> 
                                    {{ item.ocorrenciaDescricao }}
                                </td>
                                <td class="text-end" data-label="Cliente">
                                    {{ item.clienteId }}  
                                </td>
                                <td class="text-start" data-label="Nome Cliente">
                                    {{ item.clienteNome }}  
                                </td>
                                <td class="text-center" data-label="Dt Vencimento">
                                    {{ fdata(item.dataVencimento) }}  
                                </td>

                                <td class="text-end" data-label="Recebido R$">
                                    {{ f2dec(item.valorRecebido) }}
                                </td>

                                 <td class="text-end" data-label="Juros R$">
                                    {{ f2dec(item.valorMoraJuros) }}
                                </td>
                                <td class="text-end" data-label="Out Créd R$">
                                    {{ f2dec(item.valorOutrosCreditos) }}                                
                                </td>

                                <td class="text-end" data-label="Desctos R$">
                                    {{ f2dec(item.valorDescontos) }}    
                                </td>

                                <td class="text-end" data-label="Documento R$">
                                    {{ f2dec(item.valorDocumento) }}
                                </td>
                                
                                <td class="" data-label="Detalhes"  >
                                    {{ item.motivosRejeicao }}
                                </td>

                                <td class="" data-label="status Processamento"  >
                                    {{ item.statusProcessamento }}
                                </td>
                                
                                <td class="text-center" data-label="Opções">
                                    <div class="opcoes" >

                                        <a class=" btn-link me-1" href="javascript:void(0)" @click="exibirDetalhes(item)" title="Exibir detalhes do boleto">
                                            <i class="fa fa-search"></i>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> 
        </div>
    </Container>

    <nav class="navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark border-top">
        <div class="container-fluid">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    
                    
                    <!-- <li class="nav-item me-2">
                        <Paginador 
                        :paginaAtual="controle.filtros.paginaAtual" 
                        :tamanhoPagina="controle.filtros.tamanhoPagina" 
                        :totalRegistros="controle.totalRegistros" 
                        @on-change=" (r) => {
                            controle.filtros.paginaAtual = r.paginaAtual;
                            controle.filtros.tamanhoPagina = r.tamanhoPagina;
                            pesquisar();
                        }"  />
                    </li> -->

                    <li class="nav-item me-2">
                        <a class="nav-link" 
                        h href="javascript:void(0)"
                        v-if="controle.resumo.status != 2"
                        @click="perguntaProcessar(item)"
                        :disabled="controle.processandoRetorno"
                        title="Processar retorno">
                            <i class="fa fa-play"></i>
                             Processar Retorno
                        </a>

                    </li>
                   
                </ul>

                

                <div class="d-flex">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link" href="#" @click="router.back()">
                                <i class="fa fa-close"></i> Fechar
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
   
     <!-- Diálogo de Confirmação -->
    <Pergunta
        :exibir="controle.showConfirmDialog"
        titulo="Processar Retorno"
        :mensagem="`Deseja processar o retorno ${controle.filtros.retornoId}?`"
        :detalhes="`Esta ação irá atualizar os boletos conforme as informações do retorno. Deseja continuar?`"
        tipo="warning"
        textoSim="Processar"
        textoNao="Cancelar"
        :processando="controle.processandoRetorno"
        @resposta="confirmaProcessar"
    />
    
</template>

<style scoped>

.div-table-resumo {
    max-height: calc(100vh - 530px);
    min-height: calc(100vh - 530px);
    overflow: auto;
}


.div-table-boletos {
    max-height: calc(100vh - 470px);
    min-height: calc(100vh - 470px);
    overflow: auto;
}

.badge {
    font-size: 100%;
    cursor: pointer;
    text-wrap: wrap;
}

.table-selecao {
    color: #fff !important;
    background-color: #003b93 !important;
    --bs-table-bg-state: #0d6efd;
    --bs-table-color-state: #fff;
}

.opcoes {
    min-width: 95px;
}
</style>